import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxDataGridModule,
  DxDataGridComponent,
  DxTabPanelModule,
  DxTextBoxModule,
  DxSelectBoxModule,
  DxNumberBoxModule,
  DxToastModule,
  DxDropDownBoxModule,
  DxTreeViewModule,
  DxValidatorModule,
  DxCheckBoxModule,
  DxFormModule,
  DxTextAreaModule,
  DxPopupModule,
  DxValidationGroupModule,
  getElement,
} from 'devextreme-angular';
import DataGrid from 'devextreme/ui/data_grid';
import { ProjectCostTemplatesService } from 'src/app/services/project-cost-templates.service ';
import { AppGlobals } from 'src/app/app.globals';
import { custom } from 'devextreme/ui/dialog';
import { ConfigService } from 'src/app/services/config.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
import { sizeUnitFor, perUnitLabel } from '../../grid-connection/project/project-tabs/project-costs/project-costs-budget/size-unit';
interface TemplateFile {
  taskId: Number;
  file: File;
}

@Component({
    selector: 'app-templates-costs-templates',
    imports: [
        CommonModule,
        DxButtonModule,
        DxDataGridModule,
        DxTabPanelModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxNumberBoxModule,
        DxToastModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxValidatorModule,
        DxCheckBoxModule,
        DxFormModule,
        DxTextAreaModule,
        DxPopupModule,
        DxValidationGroupModule,
        SearchableDropdownDirective,
    ],
    templateUrl: './templates-costs-templates.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./templates-costs-templates.component.css']
})
export class CostsTemplatesComponent implements OnInit {
  confirmText = $localize`:@@confirmCaps:CONFIRM`;
  cancelText = $localize`:@@cancelCaps:CANCEL`;
  required = $localize`:@@required:Required`;

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;
  selectedTemplate: any = {
    id: null,
    templateName: null,
    areaTypeId: null,
    sizeRange: null,
    templateCosts: [],
  };
  selectedTabIndex: any = 0;
  costTemplates: any = [
    {
      id: 0,
      name: 'Small Roof Template',
      areaType: 'dach 1',
      size: 1000,
      costs: [
        {
          id: 1,
          category: 'Vertrieb',
          units: 'Euros',
          attractUst: true,
          costNett: 10000,
          milestone: 1,
          milestoneOffset: 1,
          milestoneOffsetDirection: 'after',
          notes: '',
        },
        {
          id: 2,
          category: 'Akquiseprovision',
          units: '€/kWp',
          attractUst: false,
          costNett: 40,
          milestone: 1,
          milestoneOffset: 1,
          milestoneOffsetDirection: 'before',
          notes: '',
        },
      ],
    },
  ];

  @ViewChild('masterGrid') masterGrid: DxDataGridComponent;
  @ViewChild('costsDataGrid') costsDataGrid: DxDataGridComponent;
  @ViewChildren(DxDataGridComponent) dataGrids: QueryList<DxDataGridComponent>;

  currentEditDetailGrid: any;
  projectSizeRanges: any = [];
  projectAreaTypes: any = [];
  // Area types with their sizeUnit (WI 3211) - projectAreaTypes above is a plain {itemId,itemName} lookup list.
  areaTypes: any[] = [];
  costCategories: any = [];
  selectedTemplateCost: any = {
    id: null,
    projectCostTemplateId: null,
    isSiteCost: false,
    isKwpCost: false,
    costCategoryId: null,
    costNett: null,
    attractsUst: false,
    costMilestoneId: null,
    milestoneOffsetValue: null,
    milestoneOffsetDirection: null,
  };
  milestones: any = [];
  treeDataSourceSorted: any = [];

  nettFormat: string = '';

  isTreeBoxOpened: boolean = false;
  deleteTemplatePopupVisible: boolean = false;

  milestoneOffsetDirections: any = [
    { text: 'Before', id: 1 },
    { text: 'After', id: 2 },
  ];
  titleRequired: string = $localize`Template Name is Required.`;
  areaTypeRequired: string = $localize`Area Type is Required.`;
  sizeRangeRequired: string = $localize`Size Range is Required.`;
  costNettRequired: string = $localize`Cost Nett is Required.`;
  confirmDelete: string = $localize`Confirm Delete`;
  descriptionPlaceholder: string = $localize`100 - 200`;

  selectedTemplateIndex: any = '';
  EPKWFormatting: boolean = false;

  get sizeUnit(): string {
    return sizeUnitFor(this.areaTypes, this.selectedTemplate.areaTypeId);
  }

  constructor(
    private projectCostTemplatesService: ProjectCostTemplatesService,
    private templateService: TemplatesService,
    private activityLog: ActivityLogService
  ) {}
  /* 

    DeleteProjectCostOnTemplate{
        "Cost": {
            "Id": 4
        },
        "Language": "German"
    }
    */

  ngOnInit() {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_COST_TEMPLATES });
    this.getCostTempaltes();
    this.templateService.getAreaTypes().then(result => {
      if (!result.hasError) this.areaTypes = result.areaTypes;
    });
  }

  getCostTempaltes() {
    this.templateService.getMilestones({}).then((result: any) => {
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.milestones = result.milestonesResultItems;
      }
    });

    this.projectCostTemplatesService.getAllProjectCostTemplates({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          console.log('Result List;', result);
          // New template objects are coming in - drop any closures cached against the old ones.
          this.cellTemplateCache?.clear();
          this.costTemplates = result.projectCostTemplates;
          this.projectSizeRanges = result.projectSizeRanges;
          this.projectAreaTypes = result.projectAreaTypes;
          this.costCategories = result.costCategories;
          this.treeDataSourceSorted = [];
          this.assignTreeListIDs(this.costCategories, 0, 0);

          for (let i = 0; i < this.costTemplates.length; i++) {
            let costTemplate = this.costTemplates[i];
            for (let a = 0; a < costTemplate.templateCosts.length; a++) {
              let templateCost = costTemplate.templateCosts[a];
              if (templateCost.milestoneOffsetValue < 0) {
                templateCost.milestoneOffsetValue = Math.abs(templateCost.milestoneOffsetValue);
              }
            }
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  writeProjectcostTemplate(template: any) {
    let ProjectCostTemplate = {
      Id: template.id,
      TemplateName: template.templateName,
      AreaTypeId: template.areaTypeId,
      SizeRange: template.sizeRange,
      TemplateCosts: template.templateCosts,
    };
    this.projectCostTemplatesService.writeProjectcostTemplate({ ProjectCostTemplate }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({
            type: 'success',
            feedback: $localize`:@@saved:Saved`,
          });
          this.getCostTempaltes();
          this.masterGrid.instance.cancelEditData();
          this.masterGrid.instance.refresh();
          this.selectedTemplate = {
            id: null,
            templateName: null,
            areaTypeId: null,
            sizeRange: null,
            templateCosts: [],
          };
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }

  onMasterRowExpanding(e) {
    this.masterGrid.instance.collapseAll(-1);
  }

  insertTemplate(e: any): void {
    console.log('insertTemplate', e);
    e.data = {
      id: null,
      templateName: null,
      areaTypeId: null,
      sizeRange: null,
      templateCosts: [],
    };
  }
  resetTemplateForAdd(): any {
    this.selectedTemplate = {
      id: null,
      templateName: null,
      areaTypeId: null,
      sizeRange: null,
      templateCosts: [],
    };
  }
  onInitNewRow(e: any): void {
    console.log('insertTemplate', e);
    e.data = {
      id: null,
      templateName: null,
      areaTypeId: null,
      sizeRange: null,
      templateCosts: [],
    };
    this.selectedTemplate = e.data;
  }

  initDeleteCostTemplate(e: any): void {
    this.deleteTemplatePopupVisible = true;
    this.selectedTemplateIndex = e.rowIndex;
  }

  deleteCostTemplate(): void {
    this.deleteTemplatePopupVisible = false;
    this.masterGrid.instance.deleteRow(this.selectedTemplateIndex);
  }

  initEditCostTemplate(e: any): void {
    console.log('initEditCostTemplate', e);
    this.masterGrid.instance.editRow(e.rowIndex);
  }

  onCostRowUpdated(e: any, cost: any): void {
    console.log(e);
    console.log('cost', cost);
    this.selectedTemplateCost.projectCostTemplateId = cost.data.id;
    this.writeProjectCostTemplateCost(this.selectedTemplateCost);
  }

  changeMilestone(e: any): void {
    console.log(e);
    this.selectedTemplateCost.costMilestoneId = e.selectedItem?.id;
    this.selectedTemplateCost.costMilestoneName = e.selectedItem?.name;
  }

  onCostRowInserted(e: any): void {
    console.log(e);
  }

  onCostEditorPrepared(e: any): void {
    console.log(e);
  }

  onTemplateEditCanceling(e: any): void {
    this.masterGrid.instance.cancelEditData();
    this.getCostTempaltes();
    console.log(e);
  }

  onCostEditCanceling(e: any, id: any): void {
    console.log(e);
    let element = document.getElementById(id);
    let instance = DataGrid.getInstance(element) as DataGrid;
    this.currentEditDetailGrid = instance;
    instance.cancelEditData();
    // instance.refresh();
  }

  showCost(e: any, data: any): void {
    console.log(e);
    console.log(data);
  }

  writeProjectCostTemplateCost(templateCost: any) {
    let Cost = {
      Id: templateCost.id,
      ProjectCostTemplateId: templateCost.projectCostTemplateId,
      IsSiteCost: templateCost.isSiteCost,
      IsKwpCost: templateCost.isKwpCost,
      CostCategoryId: templateCost.costCategoryId,
      CostNett: templateCost.costNett,
      AttractsUst: templateCost.attractsUst,
      CostMilestoneId: templateCost.costMilestoneId,
      MilestoneOffsetValue: templateCost.milestoneOffsetValue,
      MilestoneOffsetDirection: templateCost.milestoneOffsetDirection,
      Notes: templateCost.notes,
    };
    this.projectCostTemplatesService.writeProjectCostTemplateCost({ Cost }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({
            type: 'success',
            feedback: $localize`:@@saved:Saved`,
          });
          this.getCostTempaltes();
          this.masterGrid.instance.cancelEditData();
          this.onCostEditCanceling('event', this.selectedTemplateCost.projectCostTemplateId);

          this.masterGrid.instance.refresh();
          this.selectedTemplateCost = {
            id: null,
            projectCostTemplateId: null,
            isSiteCost: false,
            isKwpCost: false,
            costCategoryId: null,
            costNett: null,
            attractsUst: false,
            costMilestoneId: null,
            milestoneOffsetValue: null,
            milestoneOffsetDirection: null,
            notes: null,
          };
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  onCostEditingStart(e: any): void {
    console.log('onCostEditingStart', e);
    this.selectedTemplateCost = e.data;
  }

  addCostRow(e: any, id: any): void {
    /*         console.log(id);
                console.log(this.dataGrids); */
    this.selectedTemplateCost = {
      id: null,
      projectCostTemplateId: null,
      isSiteCost: false,
      isKwpCost: false,
      costCategoryId: null,
      costNett: null,
      attractsUst: false,
      costMilestoneId: null,
      milestoneOffsetValue: null,
      milestoneOffsetDirection: null,
      notes: null,
    };
    console.log('addCostRow', e);
    let element = document.getElementById(id);
    let instance = DataGrid.getInstance(element) as DataGrid;
    this.currentEditDetailGrid = instance;
    instance.addRow();
  }

  initDeleteCost(e: any, id: any, item: any): void {
    let errorAlert = custom({
      messageHtml: $localize`Are you sure you want to delete this Project Cost Template Cost?`,
      buttons: [
        {
          text: $localize`:@@noCaps:NO`,
          onClick: () => {
            //myAlert.show();
            AppGlobals.GlobalLoaderVisible = false;
          },
        },
        {
          text: $localize`:@@yesCaps:Yes`,
          onClick: () => {
            console.log('initDeleteCost', e, id, item);

            this.deleteCostOnTemplate(item);

            /*                         let element = document.getElementById(id);
                                                let instance = DataGrid.getInstance(element) as DataGrid;
                                                this.currentEditDetailGrid = instance;
                                                instance.deleteRow(item.rowIndex);
                                                AppGlobals.GlobalLoaderVisible = false; */
          },
        },
      ],
    });
    errorAlert.show();
  }

  initEditCost(e: any, id: any, item: any): void {
    console.log('initEditCost', e, id, item);
    let element = document.getElementById(id);
    let instance = DataGrid.getInstance(element) as DataGrid;
    this.currentEditDetailGrid = instance;
    instance.editRow(item.rowIndex);
  }

  // Exposed for templates - perUnitLabel('') must render a bare "€", never a dangling "€/".
  perUnitLabel = perUnitLabel;

  // cellTemplateFor(cost.data) is called from the template on every change-detection pass.
  // devextreme-angular's nested option setter has no equality check, so a fresh closure each
  // time makes it push a "changed" cellTemplate option every pass and re-render rows
  // continuously (same class of bug as Task 5's [items], WI 3211 fix round 2). Cache one
  // closure per template id; cleared in getCostTempaltes() whenever templates reload.
  private cellTemplateCache = new Map<any, (container: any, options: any) => void>();

  // Each expanded template's detail grid renders its own rows through this. this.sizeUnit
  // (selectedTemplate.areaTypeId) is whichever template was last opened for EDITING, not
  // necessarily the one whose rows are being displayed here - so this resolves the unit from
  // the row's own parent template (the master-detail template's `cost.data`, WI 3211 fix round 1).
  cellTemplateFor(template: any) {
    if (!this.cellTemplateCache) this.cellTemplateCache = new Map();
    const key = template?.id ?? template;
    const cached = this.cellTemplateCache.get(key);
    if (cached) return cached;

    const fn = (container: any, options: any) => {
      const otherColumnValue = options.data.isKwpCost;
      const targetValue = options.value;
      // Read live off `template`, not a value captured at cache time - a changed area type
      // (e.g. the same object mutated by an edit) must still apply.
      const unit = sizeUnitFor(this.areaTypes, template?.areaTypeId);
      const label = otherColumnValue === true ? perUnitLabel(unit) : '€';
      this.nettFormat = `#,##0.00 ${label}`;
      container.textContent = `${targetValue.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${label}`;
    };
    this.cellTemplateCache.set(key, fn);
    return fn;
  }

  saveCostTemplate(templateData: any) {
    console.log('saveCostTemplate', this.selectedTemplate);
    this.writeProjectcostTemplate(this.selectedTemplate);
  }

  addCustomSizeRangeValue(e: any) {
    console.log('addCustomSizeRangeValue');
    console.log(e);
    console.log(this.projectSizeRanges);
    const newItem = { itemName: e.text };
    // Add the new item to the items array if it doesn't already exist
    if (this.projectSizeRanges === undefined) {
      let emptyArray = [];
      this.projectSizeRanges = emptyArray;
      if (this.projectSizeRanges.length > 0 || !this.projectSizeRanges.includes(newItem)) {
        this.projectSizeRanges.push(newItem);
      }
    } else {
      if (this.projectSizeRanges.length > 0 || !this.projectSizeRanges.includes(newItem)) {
        this.projectSizeRanges.push(newItem);
      }
    }
    // Return the new item as the value for the select box
    e.customItem = newItem;
  }

  editTemplate(e: any) {
    console.log('editTemplate', e);
    this.selectedTemplate = e.data;
  }

  treeView_itemSelectionChanged(e: any, item: any) {
    if (!e?.itemData) {
      return;
    }
    item.costCategoryId = e.itemData.id;
    item.costCategoryName = e.itemData.categoryName;
    this.isTreeBoxOpened = false;
  }

  async assignTreeListIDs(categories: any, cat: any, subCat: any) {
    for (let i = 0; i < categories.length; i++) {
      if (cat === 0) {
        categories[i].treeId = i + 1;

        this.treeDataSourceSorted.push(categories[i]);
      } else {
        if (subCat != 0) {
          categories[i].treeId = cat + '_' + subCat + '_' + (i + 1);
          categories[i].treeCategoryId = cat + '_' + subCat;
          this.treeDataSourceSorted.push(categories[i]);
        } else {
          this.treeDataSourceSorted.push(categories[i]);
        }
      }
      // console.log(this.treeDataSourceSorted);

      if (categories[i].subCategories.length > 0) {
        let subCategory = categories[i].subCategories;

        for (let a = 0; a < subCategory.length; a++) {
          let idlayer = '_';
          categories[i].subCategories[a].treeId = categories[i].treeId + idlayer + (a + 1);
          categories[i].subCategories[a].treeCategoryId = categories[i].treeId;
          this.treeDataSourceSorted.push(categories[i].subCategories[a]);
          // console.log(this.treeDataSourceSorted);
          //category = subCategory[i];
          if (categories[i].subCategories[a].subCategories.length > 0) {
            this.assignTreeListIDs(categories[i].subCategories[a].subCategories, i + 1, a + 1);
          }
        }
      }
      //  console.log(this.treeDataSourceSorted);
    }
  }

  deleteTemplate(template: any) {
    this.selectedTemplate = template.data;
    this.deleteProjectCostTemplate(this.selectedTemplate);
  }

  deleteProjectCostTemplate(template: any): void {
    let ProjectCostTemplate = {
      Id: template.id,
    };

    this.projectCostTemplatesService.deleteProjectCostTemplate({ ProjectCostTemplate }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({
            type: 'success',
            feedback: $localize`:@@deleted:Deleted`,
          });
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  deleteCostOnTemplate(template: any) {
    console.log('deleteCostOnTemplate', template);
    this.selectedTemplateCost = template.data;
    this.deleteProjectCostOnTemplate(this.selectedTemplateCost);
  }

  deleteProjectCostOnTemplate(template: any): void {
    let Cost = {
      Id: template.id,
    };

    this.projectCostTemplatesService.deleteProjectCostOnTemplate({ Cost }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({
            type: 'success',
            feedback: $localize`:@@deleted:Deleted`,
          });
          this.getCostTempaltes();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  setAreaType(e: any): void {
    console.log('set areatype', e);
    this.selectedTemplate.areaTypeId = e.value;
  }
  isKwpCostChanged(e: any): void {
    if (e.value === true) {
      this.EPKWFormatting = true;
    } else {
      this.EPKWFormatting = false;
    }
  }

  iskwpInitialized(e: any): void {
    this.isKwpCostChanged({ value: e.isKwpCost });
  }
}
